<template>
  <div class="aboutHenkelWrap">
    <img @click="onHide" class="icon_close" src="static/images/icon_close.png" alt="">
    <div class="title"> <span class="triangle"></span> 关于汉高</div>
    <div class="image"><img src="static/images/img_about.jpg" alt=""></div>
    <div class="text">
      <p>汉高在全球范围内经营均衡且多元化的业务组合。通过强大的品牌、卓越的创新和先进的技术，公司在工业和消费领域的三大业务板块中确立了领先地位。汉高粘合剂技术业务部是全球粘合剂市场的领导者，服务于全球各行各业。洗涤剂及家用护理以及化妆品/美容用品两大业务也是各国市场和众多应用领域中的领先品牌。</p>
      <p>成立于1876年，汉高迄今已有145年光辉历史。汉高在全球范围内约有5.3万名员工，在强大的企业文化和共同的价值观的引领下，他们融合为一支热情、多元化的团队，为创造可持续价值这一企业目标而奋斗。作为企业可持续发展的表率，汉高在许多国际性指数和排行榜中名列前茅。汉高的优先股已列入德国DAX指数。</p>
    </div>
    <div class="logo"><img src="static/images/loading_logo.png" alt=""></div>
  </div>
</template>

<script>
export default {
  name: 'AboutHenkel',
  props: {
  },
  data () {
    return {
    }
  },
  mounted () {
    console.log(this.bgColor)
  },
  methods: {
    onHide () {
      this.$emit('onClick', { type: 'about' })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='less' scoped>
  .aboutHenkelWrap {
    width: 650px;
    height: 1134px;
    position: absolute;
    border-bottom-right-radius: 50px;
    background-image: linear-gradient(to bottom, #fff, #ebebeb);

    .icon_close {
      width: 47px;
      height: 47px;
      position: absolute;
      right: 0;
      top: -60px;
    }

    .title {
      font-size: 34px;
      padding: 40px;
      color: #202020;

      .triangle {
        display: inline-block;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 16px 0 16px 16px;
        border-color: transparent transparent transparent #e1000f;
      }
    }
    .image {
      width: 100%;
      height: 308px;
      background-color: #ccc;

      img {
        width: 100%;
      }
    }
    .text {
      font-size: 24px;
      padding: 40px 50px 0 50px;
      color: #202020;
    }
    .logo {
      width: 100%;
      text-align: right;
      padding-right: 40px;
      box-sizing: border-box;
      img {
        width: 122px;
        height: 68px;
        display: inline-block;
      }
    }
  }
</style>
